import { render, staticRenderFns } from "./AnggotaKatiSelect.vue?vue&type=template&id=048267ce&scoped=true"
import script from "./AnggotaKatiSelect.vue?vue&type=script&lang=js"
export * from "./AnggotaKatiSelect.vue?vue&type=script&lang=js"
import style0 from "./AnggotaKatiSelect.vue?vue&type=style&index=0&id=048267ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048267ce",
  null
  
)

export default component.exports